export interface IUserMicrosoftAccount {
    homeAccountId: string;
    username: string;
    name: string;
    tenantId: string;
}

export class UserMicrosoftAccount implements IUserMicrosoftAccount {
    homeAccountId: string;
    username: string;
    name: string;
    tenantId: string;

    constructor();
    constructor(obj: IUserMicrosoftAccount);
    constructor(obj?: any) {
        this.homeAccountId = obj && obj.homeAccountId || "";
        this.username = obj && obj.username || "";
        this.name = obj && obj.name || "";
        this.tenantId = obj && obj.tenantId || "";
    }
}